exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload[data-v-3d26f2ef]{display:inline-block;margin-left:10px}\n", ""]);

// exports
